import {
  recommendedStoreData,
  fetchMarketBanner,
  fetchSpecificItemsList,
  fetchSpecificItems,
  fetchAllItems,
  pharmacyStoreList,
  healthCareProducts,
  listProductFeedback,
  createQuote,
  listQutableItem,
  uploadImageToStorage,
} from "./services/index.js";
import productDataFilter from "@/shared/productDataFilter";
import { structureItemData } from "/src/helpers/items";
export default {
  namespaced: true,
  state: {
    specificItemsList: {},
    specificItems: {},
    healthCareCategories: null,
    marketBanner: {},
    recommendedStores: {},
    itemSuggestions: [],
    newArrivals: [],
    trendingItems: [],
    pharmacyStore: [],
    healthCareProductsList: [],
    defaultLocation: {
      City: "Hyderabad",
      Country: "India",
      State: "Telangana",
      zip: "500004",
    },
    productFeedbackList: [],
  },

  getters: {
    getProductFeedbackData(state) {
      return (id) => state.productFeedbackList[id] || {};
    },
  },

  actions: {
    fetchProductFeedback: async (
      { commit, state },
      payload,
      refresh = false
    ) => {
      try {
        if (!state.productFeedbackList[payload._id] || refresh) {
          let result = await listProductFeedback(payload.catalogId);
          commit("setProductFeedback", {
            key: payload._id,
            value: result?.[0],
          });
        }
      } catch (e) {
        console.log(e);
      }
    },

    uploadImageToStorage: async (_, payload) => {
      return uploadImageToStorage(payload);
    },

    createQuote: async (_, payload) => {
      return createQuote(payload);
    },

    listQutableItem: async (_, payload) => {
      return listQutableItem(payload);
    },

    fetchPharmacyStore: async ({ commit }, payload) => {
      commit("setPharmacyStore", []);
      const data = await pharmacyStoreList(payload);
      commit("setPharmacyStore", data.data.response);
    },

    fetchHealthCareProductList: async ({ commit }, payload) => {
      commit("setHealthCareProducts", []);
      const data = await healthCareProducts(payload);
      const result = data.data.hits.hits.map((each) => {
        return {
          ...each._source,
          _id: each._id,
        };
      });
      let resultFinal = await productDataFilter.methods.filterProductData(
        result
      );
      commit("setHealthCareProducts", resultFinal);
    },

    fetchSpecificItemsList: async ({ commit, state }, id, refresh = false) => {
      try {
        if (!state.specificItemsList || refresh) {
          commit("setSpecificItemsList", []);
        }
        const data = await fetchSpecificItemsList(id);
        commit("setSpecificItemsList", data);
        const result = data.filter((x) => x.isCategory);
        commit("setHealthCareCategories", result);
      } catch (e) {
        //
      }
    },
    fetchSpecificItems: async ({ commit, state }, id, refresh = false) => {
      try {
        if (!state.specificItems || refresh) {
          commit("setSpecificItems", []);
        }
        const data = await fetchSpecificItems(id);
        const result = data.filter((el)=> el.isProductType)
        commit("setSpecificItems", result);
      } catch (e) {
        //
      }
    },

    fetchMarketBanner: async ({ commit, state }, payload, refresh = false) => {
      try {
        if (!state.marketBanner || refresh) {
          commit("setMarketBanner", []);
        }
        const data = await fetchMarketBanner(payload);
        const result = data;
        commit("setMarketBanner", result);
      } catch (e) {
        //
      }
    },

    fetchRecommendedStores: async ({commit, state}, payload, refresh = false) => {
      try {
        if (!state.recommendedStores || refresh) {
          commit("setRecommendedStores", []);
        }
        const data = await recommendedStoreData(payload);
        const result = data;
        commit("setRecommendedStores", result);
      } catch (error) {
        //
      }
    },

    fetchAllItems: async ({ commit, state }, market, refresh = false) => {
      try {
        if (
          (!state.itemSuggestions.length && !state.newArrivals.length) ||
          refresh
        ) {
          commit("setState", {
            itemSuggestions: [],
            newArrivals: [],
            trendingItems: [],
            isLoading: true,
          });
          const result = await fetchAllItems({
            city: ["Ghatal"],
            market: [market],
            page: { page: 1, itemsPerPage: 20 },
          });
          commit("setState", {
            itemSuggestions: structureItemData(result.data.itemSuggestions),
            newArrivals: structureItemData(result.data.newArrivals),
            trendingItems: structureItemData(result.data.trendingItems),
            isLoading: false,
          });
        }
      } catch (e) {
        //
      }
    },
  },
  mutations: {
    setPharmacyStore(state, data) {
      state.pharmacyStore = data;
    },
    setHealthCareProducts(state, data) {
      state.healthCareProductsList = data;
    },
    setProductFeedback: (state, data) => {
      state.productFeedbackList = {
        ...state.productFeedbackList,
        [data.key]: data.value,
      };
    },
    setSpecificItemsList: (state, data) => {
      state.specificItemsList = data;
    },
    setSpecificItems: (state, data) => {
      state.specificItems = data;
    },
    setHealthCareCategories: (state, data) => {
      state.healthCareCategories = data;
    },
    setMarketBanner: (state, data) => {
      state.marketBanner = data;
    },
    setRecommendedStores: (state, data) => {
      state.recommendedStores = data;
    },
    setState: (state, data) => {
      Object.keys(data).map((field) => {
        state[field] = data[field];
      });
    },
  },
};
